import { luxonTimezone } from '@mobiscroll/react';
import * as luxon from 'luxon';

import { useAppSelector } from 'src/app/store/hooks';
import { selectCurrentOrganizationHeadquartersLocation } from 'src/features/auth/selectors';

luxonTimezone.luxon = luxon;
// Important -- prevents "Invalid unit zone" error
// Mobiscroll needs to determine the version I believe
// due to using a custom createObject implementation
// luxon changed the signature of createObject in v2
luxonTimezone.version = 3;

export function useMobiscrollTimezoneProps() {
  const hqLocation = useAppSelector(
    selectCurrentOrganizationHeadquartersLocation
  );

  return {
    dataTimezone: 'utc',
    timezonePlugin: luxonTimezone,
    displayTimezone: hqLocation?.time_zone_name,
  };
}
